//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { GetClientRetailersResponse } from '@apis/campaign-requests/sampling/retailers/samplingRetailersApiModel';
import { useGetClientRetailersQuery } from '@campaigns/components/campaign-requests/sampling-campaigns/SamplingCampaignsQueries';
import ClientId from '@models/ClientId';
import { getClientId } from '@redux/selectors/getClientId';

const isRetailerClient = (
  data: GetClientRetailersResponse,
  clientId: ClientId,
) => data.results.some((retailer) => retailer.clientId === clientId);

export const useIsRetailerClient = () => {
  const clientId = useSelector(getClientId);
  return useGetClientRetailersQuery((data) => isRetailerClient(data, clientId));
};
